import SummaryApi from "../common"
import { toast } from 'react-toastify'
import service from "../common/HttpService"

const addToCart = async (e, product, userId, optionalRateId = "", initialQuantity = 1) => {
    e?.stopPropagation()
    e?.preventDefault()

    if (!userId) {
        toast.error("Please login to add items to cart")
        return { error: true }
    }

    try {
        // Handle case where product is passed just as an ID string directly (backward compatibility)
        const isStringId = typeof product === 'string';
        let extractedId = isStringId ? product : (product?.id || product?.product_id || product?._id || "");

        // Ensure productId is purely numeric, if it's not we pull only numbers, and fallback to "1"
        let productId = String(extractedId).replace(/[^0-9]/g, '');
        if (!productId) productId = "1";

        // Extract rate info
        let rate = null;
        const allRates = (Array.isArray(product?.item_rates) && product.item_rates.length > 0)
            ? product.item_rates
            : ((Array.isArray(product?.item_rate) && product.item_rate.length > 0)
                ? product.item_rate
                : (Array.isArray(product?.rates) ? product.rates : []));
        if (!isStringId && allRates.length > 0) {
            rate = optionalRateId ? allRates.find(r => String(r.id) === String(optionalRateId) || String(r._id) === String(optionalRateId)) : allRates[0];
            if (!rate) rate = allRates[0];
        }

        let vendorId = String(isStringId ? "1" : (product?.vendor_id || product?.user_id || "1")).replace(/[^0-9]/g, '');
        if (!vendorId) vendorId = "1";

        let rateId = String(rate?.id || rate?._id || optionalRateId || "").replace(/[^0-9]/g, '');
        if (!rateId) rateId = "1";

        let unitId = String(rate?.unit_id || rate?.uom_id || product?.unit_id || "1").replace(/[^0-9]/g, '');
        if (!unitId) unitId = "1";

        let salerate = String(rate?.salerate || product?.sellingPrice || product?.price || "0").replace(/[^0-9.]/g, '');
        if (!salerate) salerate = "0";

        const quantity = String(initialQuantity || "1");
        const type = "2"; // 1 = buy_now, 2 = cart (assuming standard add to cart is 2)

        const formData = new FormData();
        formData.append('user_id', String(userId));
        formData.append('product_id', String(productId));
        // formData.append('productId', String(productId));
        formData.append('quantity', String(quantity));
        formData.append('qty', String(quantity));
        formData.append('item_rate_id', String(rateId));
        formData.append('rate_id', String(rateId));
        formData.append('vendor_id', String(vendorId));
        formData.append('unit_id', String(unitId));
        formData.append('salerate', String(salerate));
        formData.append('type', String(type));


        console.log("Adding to cart payload:", {
            user_id: userId, product_id: productId, qty: quantity, vendor_id: vendorId, unit_id: unitId, salerate: salerate, type: type, rate_id: rateId
        });

        const responseData = await service.post(SummaryApi.add_to_cart.url, formData);

        if (responseData.success === "true" || responseData.success === true) {
            toast.success(responseData.message || "Product added to cart successfully");
            return responseData;
        } else {
            console.error("Add to cart failed:", responseData);
            toast.error(responseData.message || "Failed to add to cart");
            return { error: true };
        }
    } catch (error) {
        console.error("Add to cart error:", error);
        toast.error(error?.data?.message || error?.message || "Error adding item to cart");
        return { error: true };
    }
}

export default addToCart